import axios from '@fs/zion-axios'
import convertFromS3 from './convert-from-s3'
import { AncestorData } from '../types/data-types'
import { treeDataBaseUrl } from './url-service'

export default async function readData(pid: string): Promise<AncestorData> {
  const endpointUrl = `${treeDataBaseUrl}/published/persons/${pid}`
  try {
    const response = await axios.get(endpointUrl)
    return convertFromS3(response.data)
  } catch (error) {
    console.error(`Error reading ${treeDataBaseUrl}/${pid}`, error)
    throw error
  }
}
